/**
 * Shared color/typography tokens for every chart across the six dashboards
 * (Phase 4, execution_strategy_activity_tracker.md), so they read as one
 * system instead of six one-offs. Hex values mirror the CSS custom
 * properties in styles/uz-teal-theme.css and the badge colors already used
 * in ModernDashboard.css (active/pending/completed/closed) - reusing them
 * here keeps chart legends visually consistent with the status badges
 * already shown elsewhere on the same pages, rather than introducing a
 * second, unrelated color vocabulary.
 *
 * Recharts consumes plain hex strings (SVG fill/stroke attributes resolve
 * CSS custom properties inconsistently across browsers), so these are
 * duplicated as literal values rather than read from the CSS file.
 */

export const CHART_COLORS = {
    teal: '#0ab39c',
    tealDark: '#099885',
    indigo: '#405189',
    amber: '#f7b84b',
    coral: '#f06548',
    violet: '#8b5cf6',
    slate: '#64748b',
} as const;

/** Fixed order - never cycle/reassign by rank, a filtered series keeps its color. */
export const CATEGORICAL_SEQUENCE = [
    CHART_COLORS.teal,
    CHART_COLORS.indigo,
    CHART_COLORS.amber,
    CHART_COLORS.coral,
    CHART_COLORS.violet,
    CHART_COLORS.slate,
];

export const STATUS_COLORS = {
    good: CHART_COLORS.teal,
    warning: CHART_COLORS.amber,
    critical: CHART_COLORS.coral,
};

export const CHART_INK = {
    axis: '#878a99',
    grid: '#f3f3f9',
    label: '#2a3547',
};

export const CHART_FONT = {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 12,
};
